/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Portal_Specialist_CrumbInputs */

const en_booking_portal_specialist_crumb = /** @type {(inputs: Booking_Portal_Specialist_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specialist`)
};

const pl_booking_portal_specialist_crumb = /** @type {(inputs: Booking_Portal_Specialist_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener`)
};

/**
* | output |
* | --- |
* | "Specialist" |
*
* @param {Booking_Portal_Specialist_CrumbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_portal_specialist_crumb = /** @type {((inputs?: Booking_Portal_Specialist_CrumbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Portal_Specialist_CrumbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_portal_specialist_crumb(inputs)
	return en_booking_portal_specialist_crumb(inputs)
});